import React from 'react';
import { Check, Star, ShieldCheck, Truck, Clock } from 'lucide-react';
export function AdvertorialSidebar() {
  return <div className="lg:sticky lg:top-24 space-y-6" data-id="element-46">
      {/* Main Product Card */}
      <div className="bg-white border-2 border-[#2B7FD9]/20 rounded-xl shadow-lg overflow-hidden" data-id="element-47">
        <div className="bg-[#2B7FD9] text-white text-center py-2 font-bold text-sm uppercase tracking-wide" data-id="element-48">
          Limited Time Offer
        </div>

        <div className="p-6" data-id="element-49">
          <div className="aspect-square bg-gray-100 rounded-lg mb-4 flex items-center justify-center overflow-hidden relative group" data-id="element-50">
            <img src="https://cdn.magicpatterns.com/uploads/wuUxh4orGbppfqH7m5hgZN/product_image.png" alt="Barkvee Knee Wrap Product" className="object-contain w-full h-full" data-id="element-51" />
            <div className="absolute top-2 right-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded shadow-sm" data-id="element-52">
              50% OFF
            </div>
          </div>

          <h3 className="font-sans font-bold text-xl text-gray-900 mb-2 leading-tight" data-id="element-53">
            Barkvee Heated Knee Comfort Wrap
          </h3>

          <div className="flex items-center gap-2 mb-4" data-id="element-54">
            <div className="flex" data-id="element-55">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-[#FFD700] text-[#FFD700]" data-id="element-56" />)}
            </div>
            <span className="text-sm text-gray-500 font-medium" data-id="element-57">
              (2,400+ Reviews)
            </span>
          </div>

          <div className="space-y-2 mb-6" data-id="element-58">
            <div className="flex items-start gap-2" data-id="element-59">
              <Check className="w-4 h-4 text-[#28A745] mt-1 shrink-0" data-id="element-60" />
              <span className="text-sm text-gray-600" data-id="element-61">
                Soothing therapeutic heat
              </span>
            </div>
            <div className="flex items-start gap-2" data-id="element-62">
              <Check className="w-4 h-4 text-[#28A745] mt-1 shrink-0" data-id="element-63" />
              <span className="text-sm text-gray-600" data-id="element-64">
                Adjustable compression support
              </span>
            </div>
            <div className="flex items-start gap-2" data-id="element-65">
              <Check className="w-4 h-4 text-[#28A745] mt-1 shrink-0" data-id="element-66" />
              <span className="text-sm text-gray-600" data-id="element-67">
                Cordless & rechargeable design
              </span>
            </div>
          </div>

          <a href="https://barkvee.com/products/knee-comfort-pad" target="_blank" rel="noopener noreferrer" className="w-full bg-[#2B7FD9] hover:bg-[#1a5bb5] text-white font-bold py-4 px-6 rounded-lg shadow-md transition-all transform hover:-translate-y-0.5 mb-4 text-lg block text-center" data-id="element-68">
            Check Availability
          </a>

          <div className="flex items-center justify-center gap-4 text-xs text-gray-500" data-id="element-69">
            <div className="flex items-center gap-1" data-id="element-70">
              <ShieldCheck className="w-4 h-4" data-id="element-71" />
              <span data-id="element-72">60-Day Guarantee</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-73">
              <Truck className="w-4 h-4" data-id="element-74" />
              <span data-id="element-75">Free Shipping</span>
            </div>
          </div>
        </div>
      </div>

      {/* Trust/Social Proof Section */}
      <div className="bg-gray-50 rounded-xl p-6 border border-gray-200" data-id="element-76">
        <h4 className="font-sans font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-77">
          <Clock className="w-5 h-5 text-[#2B7FD9]" data-id="element-78" />
          Why Order Now?
        </h4>
        <p className="text-sm text-gray-600 mb-4" data-id="element-79">
          Due to high demand from recent media exposure, inventory is limited.
          We recommend checking availability immediately to secure your order.
        </p>
        <div className="h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-80">
          <div className="h-full bg-orange-500 w-3/4 animate-pulse" data-id="element-81"></div>
        </div>
        <p className="text-xs text-orange-600 mt-2 font-medium" data-id="element-82">
          Low Stock Alert: Only 14 units left in your region.
        </p>
      </div>
    </div>;
}